var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterCloseButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L10 10",
    stroke: "url(#paint0_linear_3683_5750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1L1 10",
    stroke: "url(#paint1_linear_3683_5750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3683_5750",
    x1: 1,
    y1: 5.5,
    x2: 10,
    y2: 5.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#871C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3683_5750",
    x1: 5.5,
    y1: 1,
    x2: 5.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D81524"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#871C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterCloseButton);
export default __webpack_public_path__ + "static/media/filter-close-button.5ad9aa28fc5417819d3b9cac509ab905.svg";
export { ForwardRef as ReactComponent };